import type { ReactNode, ReactElement } from 'react';

import HooksProvider from '@virtuslab/nfs-shared/src/components/organisms/HooksProvider';
import SharedServicesProvider from '@virtuslab/nfs-shared/src/components/organisms/ServicesProvider';

import { hooks, documents } from '../../../config/hooks';

import TranslationsProvider from '../TranslationsProvider';

type Props = Readonly<{
  children: ReactNode;
}>;

const ServicesProvider = ({ children }: Props): ReactElement => (
  <TranslationsProvider>
    <HooksProvider hooks={hooks} documents={documents}>
      <SharedServicesProvider>
        {children}
      </SharedServicesProvider>
    </HooksProvider>
  </TranslationsProvider>
);

export default ServicesProvider;
